/** Format a price number to USD display */
export function formatPrice(value: any): string {
  const num = Number(value);
  if (!value || isNaN(num)) return '';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

/** Format an ISO timestamp to "MM/DD/YYYY at H:MM AM ET" */
export function formatTimestamp(isoString: string): string {
  if (!isoString) return '';
  try {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return '';

    const dateStr = date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      timeZone: 'America/New_York',
    });
    const timeStr = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/New_York',
    });

    return `${dateStr} at ${timeStr} ET`;
  } catch {
    return '';
  }
}

/** Format a phone number to (XXX) XXX-XXXX */
export function formatPhone(phone: string): string {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return phone;
}

/** Format a value based on its type. Boolean becomes Yes/No. */
export function formatValue(value: any, format?: 'price'): string {
  if (typeof value === 'boolean' || ['true', 'false'].includes(value)) {
    return value === true || value === 'true' ? 'Yes' : 'No';
  }
  if (format === 'price') {
    return formatPrice(value);
  }
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}
